/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslation } from '@axo/shared/i18n';
import { DataSharingStatus } from '@axo/shared/types';
import { Icon } from '@axo/ui-core/components/Icon';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Spinner } from '@axo/ui-core/components/Spinner';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import { ESkatLoggedIn, useESkat } from '../../../ESkat';
import { ESkatLoginButton } from '../../../ESkat/ESkatLoginButton';
import type { DenmarkFormData } from '../../FormData.dk.types';

export const ESkatDebtFormGroup = () => {
  const { t } = useTranslation();

  const { dataSharingStatus } = useAxoFormContext<DenmarkFormData>();

  const { logged: isESkat, loading } = useESkat();

  if (loading) {
    return <Spinner />;
  }

  if (isESkat) {
    return <ESkatLoggedIn />;
  }

  // TOOD: ESkat login is not working on Step 7 DK
  return null;

  return (
    <>
      {dataSharingStatus === DataSharingStatus.Enabled && (
        <ESkatLoginButton>
          <Stack direction="h" gap="2xs">
            {t('Debts.eskat')}
            <Icon name="external-link" />
          </Stack>
        </ESkatLoginButton>
      )}
    </>
  );
};
